import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HelpComponent } from './help.component';
import { TranslateModule } from '@ngx-translate/core';
import { ScreenShellComponent } from "../shared/screen-shell/screen-shell.component";

@NgModule({
  imports: [
    CommonModule, FormsModule, TranslateModule, ScreenShellComponent
  ],
  exports: [HelpComponent],
  declarations: [HelpComponent],
  providers: []
})
export class HelpModule { }
